export const SUBSCRIPTION_POPUP = 'SUBSCRIPTION_POPUP';
export const SUBSCRIPTION_POPUP_FOOTER = 'SUBSCRIPTION_POPUP_FOOTER';
